'use client';

import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Text } from '../text/text';
import { ButtonRootContext } from './context/button-root.context';
import { buttonLabelRecipe } from './styles/button-label.styles';
import type { ButtonLabelPropsInterface } from './types/button-label.types';

/**
 * @since 10.0.0
 */
export const ButtonLabel = forwardRef<HTMLSpanElement, ButtonLabelPropsInterface>(
  (props: ButtonLabelPropsInterface, forwardedRef) => {
    const {
      tone = 'brand',
      emphasis = 'outlined',
      disabled = false,
      onImpact = false,
      size = 'md',
      loading = false,
    } = useContext(ButtonRootContext);
    const { className, css: cssProp, ...rest } = props;

    return (
      <Text
        aria-disabled={disabled}
        ref={forwardedRef}
        data-c11n-component="Button.Label"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...buttonLabelRecipe.raw({ tone, emphasis, disabled, onImpact, loading, size }),
          ...cssProp,
        }}
        className={cx('c11n_button__label', className)}
        {...rest}
      />
    );
  },
);

ButtonLabel.displayName = 'Button.Label';
